// =============================================================
// 公司信息数据
// 来源：PRD §4.5 关于我们 / §4.1.9 页脚
// =============================================================

export const company = {
  name: '江苏宜航信息技术有限公司',
  intro:
    '江苏宜航信息技术有限公司，一站式零售收银与门店管理系统服务商，为文创、饰品、潮玩、谷子、服装、珠宝、美妆、手作、杂货等审美新零售门店及个体商贸客户打造智能化收银系统。',
  mission: '帮助商户把好品味做成好生意，让门店经营更高效、更轻松、更懂年轻人。',
  service: '专业研发 / 售后团队持续保驾护航。',
  // 合规信息
  beian: '苏公网安备 32118102001260 号',
  copyright: '© 2024 江苏宜航信息技术有限公司',
}



// WEBPACK FOOTER //
// ./src/site/data/company.js